import React from "react";
import ArtworkCard from "../cardHolders/artworksCardProfile";
import ArtworkCard_ from "../cardHolders/artworksCard";
import Button from "react-bulma-components/lib/components/button";
import Modal from "react-bulma-components/lib/components/modal";
import FollowersList from "./followersList";
import "../../styles/artworks.css";
import { Redirect } from "react-router-dom";
import { inject, observer } from "mobx-react";
import { toast } from 'react-toastify';
import { overFlowHidden, removeOverFlowHidden } from '../../helpers/reusable.js'
import ShareMenu from '../../helpers/shareTheUrl'
import { DropdownToggle, UncontrolledDropdown } from "reactstrap";
import {
    validateIfInputHasCharacters,
    validateIfInputHasSpaces,
    validateIfInputHasUpperCaseLetter,
    validateIfInputHasYourMasterpieces,
    validateInputLength
} from "../../helpers/validationChecks";
import OB1 from '../Home/onboarding/onboarding1-modal'
import OB2 from '../Home/onboarding/onboarding2-modal'
import OB3 from '../Home/onboarding/onboarding3-modal'

const uploadArtIcon = require('../../assets/upload_icon_svg.svg')


@inject('userStore', 'navigatorStore', 'authStore', 'commonStore', 'landingPageArtworksStore', 'artworksStore', 'artistDetails', 'followAndLikeStore')
@observer
export default class ArtistDetails extends React.Component {
    constructor(props) {
        super(props);
       // console.log("Url With Name ", this.props.match.url);
        const Id = ArtistIdFromUrl(this.props.match.url);
      //  console.log("Artist ID", Id);
        this.state = {
            followedThisArtist: false,
            // followedThisArtist: false,
            viewFollowersList: false,
            viewFollowingList: false,
            uploadArt: false,
            readInstructions: false,
            wantsToContinue: false,
            myOwnProfile: false,
            artworkClicked: false,
            artistData: false,
            collection: false,
            artistId: false,
            followersList: false,
            followingList: false,
            artist_profile_tags: [],


            letsSee: 0,
            uniqueContainerIdFollowers: "container_followers" + new Date().getTime() + Math.random(),
            uniqueContainerIdFollowing: "container_following" + new Date().getTime() + Math.random(),
        }
    }
    handelFollowersListClick() {
        if (!localStorage.hasOwnProperty("userData")) {
            this.props.navigatorStore.openSignInModal();
            return;
        }

      //  console.log("open follwoers modal");
        this.setState({
            // loadingFollowList: true,
            viewFollowersList: !this.state.viewFollowersList,
        }, () => {
            if (!this.state.viewFollowersList) {
                this.props.followAndLikeStore.reset()
            }
            () => { overFlowHidden() }
            
        })




    }
    toggleBuyingTab() {
        this.setState({
            buyingTab: "visible",
            sellingTab: "hidden"

        })
        console.log("buying", this.state.buyingTab)
        console.log("selling", this.state.sellingTab)
    }
    toggleSellingTab(label) {
       
        if (label.includes("COLLECTION")) {


        }
        else return;
     
    }
    handleArtworkClick() {
        this.setState({
            artworkClicked: !this.state.artworkClicked
        })
    }
    handelFollowingListClick() {
      
        if (!localStorage.hasOwnProperty("userData")) {
            this.props.navigatorStore.openSignInModal();
            return;
        }
        this.setState({
            loadingFollowList: true,

            viewFollowingList: !this.state.viewFollowingList,
        }, () => {
            if (!this.state.viewFollowingList) {
                this.props.followAndLikeStore.reset()
            }
            () => overFlowHidden()
          /*   this.props.followAndLikeStore.followingList(this.state.artistId)
                .then((res) => {
                    
                    this.setState({
                        loadingFollowList: false,
                        // followingList: res.data.data,
                        // followingCount: res.data.count
                    }
                        ,
                         () => overFlowHidden()
                    )
                }) */
        })
    }

    trackScrolling = () => {
        var wrappedElement;

        if (this.state.viewFollowersList) {
            wrappedElement = document.getElementById(this.state.uniqueContainerIdFollowers);
        }
        else if (this.state.viewFollowingList) {
            wrappedElement = document.getElementById(this.state.uniqueContainerIdFollowing);

        }
        // console.log("wrappedElement", wrappedElement)
        let reachedPageEndNow = this.isBottom(wrappedElement);
        // console.log('[trackScroll] ', { reachedPageEndNow, reachedPageEnd: this.state.reachedPageEnd });
        if (this.isBottom(wrappedElement)) {
            // console.log('[trackScroll] FAKE ');
        };
        if ((reachedPageEndNow && !this.state.reachedPageEnd) || (!reachedPageEndNow && this.state.reachedPageEnd)) {
            this.setState({ reachedPageEnd: reachedPageEndNow })
            // reachedPageEndNow && console.log('[trackScroll] REAL ');
            if (reachedPageEndNow) {
                this.loadFunc()
            }
        }
    };
    loadFunc() {
        this.props.followAndLikeStore.loadMore(this.state.viewFollowersList, this.state.viewFollowingList)
    }
    componentWillUnmount() {
        // console.log("unmounted")
        document.removeEventListener('scroll', this.trackScrolling);
        this.props.artworksStore.resetCollection()
        this.props.artistDetails.reset()
        // localStorage.removeItem("preferred_dimension");

        // this.props.searchPageArtworksStore.resetPagination();
    }

    handelFollowRequest() {
        // console.log("followed you this is artist data", this.state.followedThisArtist);
        this.setState({
            followedThisArtist: !this.state.followedThisArtist
        }, function () {
            // console.log("followed you this is artist data", this.state.followedThisArtist);
            (this.state.followedThisArtist) ?

                this.props.followAndLikeStore.followTheArtist(this.state.artistId)
                    .then((res) => {
                        toast("You are now following this user")
                        this.loadArtistData(this.props.match.params.id, true)
                    }) :
                this.props.followAndLikeStore.unFollowTheArtist(this.state.artistId)
                    .then((res) => {
                        toast("You have unfollowed this user")
                        this.loadArtistData(this.props.match.params.id, true)
                    })
        });
    }

    onCloseFollowers() {
        this.setState({ viewFollowersList: false }, () => {
            removeOverFlowHidden();

            this.loadArtistData(this.props.match.params.id, true, false, true)
        });
    }
    onCloseFollowing() {
        this.setState({ viewFollowingList: false }, () => {
            removeOverFlowHidden()
            this.loadArtistData(this.props.match.params.id, true, false, true)
        });

    }
    handleReadInstructionsCheck() {
       
        this.setState({
            readInstructions: !this.state.readInstructions
        })
    }
    close = () => this.setState({ uploadArt: false });

    handelUploadArtBtnClick() {
        this.setState({
            uploadArt: !this.state.uploadArt
        })
    }

    handelContinueClick() {
        this.setState({
            wantsToContinue: !this.state.wantsToContinue
        })
    }

    loadArtistData(id, hide, publicAPI, notAllDataRequired) {
        // var artistId;
        if (notAllDataRequired) this.props.artistDetails.reset();
        if (publicAPI) {

            this.props.artistDetails.getArtistDetailsPublic(id, hide)

                .then((resp) => {
                  
                    // artistId: resp.data.data[0].id;
                    if (!notAllDataRequired) {
                        this.setState({
                            artworkCount: resp.data.count,
                            artistData: resp.data.data,
                            followersCount: (resp.data.count) ? resp.data.data[0].user_profile.followers : resp.data.data.user_profile.followers,
                            following: (resp.data.count) ? resp.data.data[0].user_profile.following : resp.data.data.user_profile.following,
                            collectionCount: (resp.data.count) ? resp.data.data[0].user_profile.total_likes_given : resp.data.data.user_profile.total_likes_given,
                            followedThisArtist: (resp.data.count) ? resp.data.data[0].isfollowing : resp.data.data.user_profile.isfollowing,
                            artistId: (resp.data.count) ? resp.data.data[0].user_profile.id : resp.data.data.user_profile.id,
                            myOwnProfile: (id == localStorage.getItem("profile_id"))
                        }, function () {
                            // console.log("this is artist data", this.state.artistData)
                            // var tags = [];
                            /* user tags logic */
                            if (this.state.artistData && this.state.artistData[0]) {
                                this.artistProfileTagsIdentifier(this.state.artistData[0])
                            }
                            else if (this.state.artistData) {
                                this.artistProfileTagsIdentifier(this.state.artistData)
                            }
                            // this.loadOtherData(this.state.artistId, hide)
                        }
                        )
                    } else {


                        this.setState({

                            followersCount: (resp.data.count) ? resp.data.data[0].user_profile.followers : resp.data.data.user_profile.followers,
                            following: (resp.data.count) ? resp.data.data[0].user_profile.following : resp.data.data.user_profile.following,

                        }, function () {
                            // console.log("this is artist data", this.state.artistData)
                            // var tags = [];
                            /* user tags logic */
                            if (this.state.artistData && this.state.artistData[0]) {
                                this.artistProfileTagsIdentifier(this.state.artistData[0])
                            }
                            else if (this.state.artistData) {
                                this.artistProfileTagsIdentifier(this.state.artistData)
                            }
                            // this.loadOtherData(this.state.artistId, hide)
                        }
                        )
                    }
                })
        } else {

            this.props.artistDetails.getArtistDetailsPrivate(id, hide)
                .then((resp) => {
                    // console.log("this is artist data", resp);
                    if (!notAllDataRequired) {
                        // artistId: resp.data.data[0].id;
                        this.setState({
                            artworkCount: resp.data.count,
                            artistData: resp.data.data,
                            followedThisArtist: (resp.data.count) ? resp.data.data[0].isfollowing : resp.data.data.user_profile.isfollowing,
                            followersCount: (resp.data.count) ? resp.data.data[0].user_profile.followers : resp.data.data.user_profile.followers,
                            following: (resp.data.count) ? resp.data.data[0].user_profile.following : resp.data.data.user_profile.following,
                            collectionCount: (resp.data.count) ? resp.data.data[0].user_profile.total_likes_given : resp.data.data.user_profile.total_likes_given,
                            // followedThisArtist: (resp.data.count) ? resp.data.data[0].isfollowing : resp.data.data.user_profile.isfollowing,
                            artistId: (resp.data.count) ? resp.data.data[0].user_profile.id : resp.data.data.user_profile.id,
                            myOwnProfile: (id == localStorage.getItem("profile_id"))
                        }, function () {

                            this.props.followAndLikeStore.followingList(this.state.artistId)
                            .then((res) => {
                                // console.log(res);
                                this.setState({
                                    followingList: res.data.data,
                                    followingCount: res.data.count,
                                    loadingFollowList: false
                
                                })
                            })
                        this.props.followAndLikeStore.followersList(this.state.artistId)
                            .then((res) => {
                                // console.log(res);
                                this.setState({
                                    followersList: res.data.data,
                                    followersCount: res.data.count
                                })
                            })
                            // console.log("this is artist data", this.state.artistData)
                            // var tags = [];
                            /* user tags logic */
                            if (this.state.artistData && this.state.artistData[0]) {
                                this.artistProfileTagsIdentifier(this.state.artistData[0])
                            }
                            else if (this.state.artistData) {
                                this.artistProfileTagsIdentifier(this.state.artistData)
                            }
                            this.loadOtherData(this.state.artistId, hide)
                        }
                        )
                    } else {


                        this.setState({

                            followersCount: (resp.data.count) ? resp.data.data[0].user_profile.followers : resp.data.data.user_profile.followers,
                            following: (resp.data.count) ? resp.data.data[0].user_profile.following : resp.data.data.user_profile.following,

                        }, function () {
                            // console.log("this is artist data", this.state.artistData)
                            // var tags = [];
                            /* user tags logic */
                            if (this.state.artistData && this.state.artistData[0]) {
                                this.artistProfileTagsIdentifier(this.state.artistData[0])
                            }
                            else if (this.state.artistData) {
                                this.artistProfileTagsIdentifier(this.state.artistData)
                            }
                            // this.loadOtherData(this.state.artistId, hide)
                        }
                        )
                    }
                })
        }


    }

    loadOtherData(artistId, hide) {

        // this.props.artworksStore.getArtworkCollection(artistId, true)
        //     .then((resp) => {
        //         console.log("this is collection data", resp);
        //         this.setState({
        //             // collectionCount: resp.data.count,
        //             collection: resp.data.data,
        //             buyingTab: "hidden",
        //             sellingTab: "visible"
        //             // followedThisArtist: (resp.data.data.length) ? resp.data.data[0].user_profile.isfollowing : resp.data.data.user_profile.isfollowing,
        //             // artistId: str.replace(/\D/g, "")
        //         }, function () {
        //             console.log(resp)
        //         })
        //     });

    }
    isBottom(el) {
        return el.getBoundingClientRect().bottom <= window.innerHeight;
    }
    componentDidMount() {
        // console.log("mounted profile", this.props.match.params.id)
        var str = this.props.match.params.id;
        this.props.artistDetails.reset();
        document.addEventListener('scroll', this.trackScrolling);

        if (localStorage.hasOwnProperty("userData")) {
            this.loadArtistData(str)

            this.setState({
                viewPortWidth:
                    document.documentElement.clientWidth > 1300 ? 350 : 250
            });

            this.props.userStore.pulluser().then((result) => {
                // console.log("{this is pulled user}", result)
                if (!result.data[0].display_name && !!result.data[0].old_display_name) {
                    if ((result.data[0].old_display_name) && !validateInputLength(result.data[0].old_display_name, 6, 30)) {
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        // this.props.navigatorStore.openErrorModal("username should contain 6-30 characters");
                        this.setState({
                            onboardingThreeIncomplete: true,
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && !validateIfInputHasSpaces(result.data[0].old_display_name, 6, 30)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain spaces")
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && validateIfInputHasCharacters(result.data[0].old_display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain characters");
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && validateIfInputHasUpperCaseLetter(result.data[0].old_display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain an uppercase letter")
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && validateIfInputHasYourMasterpieces(result.data[0].old_display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain yourmasterpieces in it")
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    var formData = new FormData();
                    formData.append("display_name", this.state.formInputs.display_name)
                    // if (!!this.state.formInputs.display_name && (this.state.curr_display_name != this.state.formInputs.display_name))
                    this.props.userStore.validateDisplayName(formData)
                        .then((response) => {
                            // console.log(response)
                            if (response.error == "True") {
                                // console.log("tell i am coming here at leats")
                                this.props.navigatorStore.openOB3Modal();
                                this.setState({
                                    onboardingThreeIncomplete: true,
                                    // formInputs: { ...this.state.formInputs, display_name: "" }
                                })
                                // this.props.navigatorStore.openErrorModal(response.data)
                                return;
                            }
                            else {
                                // console.log("tell i am coming here at leats")
                                this.props.navigatorStore.openOB3Modal();
                                this.setState({
                                    onboardingThreeIncomplete: true
                                })
                            }
                        })
                        .catch((err => {
                            // console.log("tell i am coming here at leats")
                            this.props.navigatorStore.openOB3Modal();
                            this.setState({
                                onboardingThreeIncomplete: true,



                            })
                        }));
                }

                if (result.data[0].display_name) {
                    if ((result.data[0].display_name) && !validateInputLength(result.data[0].display_name, 6, 30)) {
                        // this.props.navigatorStore.openErrorModal("username should contain 6-30 characters");
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && !validateIfInputHasSpaces(result.data[0].display_name, 6, 30)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain spaces")
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && validateIfInputHasCharacters(result.data[0].display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain characters");
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && validateIfInputHasUpperCaseLetter(result.data[0].display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain an uppercase letter")
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && validateIfInputHasYourMasterpieces(result.data[0].display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain yourmasterpieces in it")
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                }

                if (!result.data[0].full_name ||
                    !result.data[0].country ||
                    //  !response.data.user_profile[0].full_name || 
                    //  !response.data.user_profile[0].user.email || 
                    //  !response.data.user_profile[0].display_name || 
                    !result.data[0].display_name ||
                    result.data[0].display_name.length >= 30 ||
                    !result.data[0].primary_email ||
                    !result.data[0].preferred_currency

                ) {
                    // console.log("profile null")
                    // console.log("tell i am coming here at leats")
                    this.props.navigatorStore.openOB3Modal();
                    this.setState({
                        onboardingThreeIncomplete: true
                    })
                    // this.state.makeOnboardingThreeIncomplete()
                }
        
            })
        } else {
            this.setState({ shareUrl: true },
                () => {

                    this.loadArtistData(str, true, true),
                        this.setState({
                            viewPortWidth:
                                document.documentElement.clientWidth > 1300 ? 350 : 250
                        });
                }
            )
        }

    }

    artistProfileTagsIdentifier(data) {
        var tags = [];
        if (data.user_profile.total_artworks_uploaded == 0 &&
            data.user_profile.total_likes_given == 0 &&
            data.user_profile.following == 0) {
            tags.push('NEW USER')
        }
        if (data.user_profile.total_artworks_uploaded == 0 &&
            data.user_profile.total_likes_given == 0 &&
            data.user_profile.following > 0) {
            tags.push('EXPLORER')
        }
        if (data.user_profile.total_artworks_uploaded > 0 &&
            data.user_profile.total_likes_given == 0 &&
            data.user_profile.following == 0) {
            tags.push('ARTIST')
        }
        if (data.user_profile.total_artworks_uploaded == 0 &&
            data.user_profile.total_likes_given > 0 &&
            data.user_profile.following == 0) {
            tags.push('ART LOVER')
        }
        if (data.user_profile.total_artworks_uploaded == 0 &&
            data.user_profile.total_likes_given > 0 &&
            data.user_profile.following > 0) {
            tags.push('ART LOVER')
            tags.push('EXPLORER')
        }
        if (data.user_profile.total_artworks_uploaded > 0 &&
            data.user_profile.total_likes_given > 0 &&
            data.user_profile.following == 0) {
            tags.push('ARTIST')
            tags.push('ART LOVER')
        }
        if (data.user_profile.total_artworks_uploaded > 0 &&
            data.user_profile.total_likes_given == 0 &&
            data.user_profile.following > 0) {
            tags.push('ARTIST')
            tags.push('EXPLORER')
        }
        if (data.user_profile.total_artworks_uploaded > 0 &&
            data.user_profile.total_likes_given > 0 &&
            data.user_profile.following > 0) {
            tags.push('ARTIST')
            tags.push('ART LOVER')
            tags.push('EXPLORER')
        }
        console.log("[user tags]", tags)
        this.setState({

            artist_profile_tags: tags
        })
    }

    isBottom(el) {
        // return el.getBoundingClientRect().bottom <= window.innerHeight;
    }
    // componentWillUpdate(){
    //     console.log('[mounted] componentWillReceiveProps srchpage nextProps ', { nextProps }, nextProps.commonStore.token, nextProps.userStore.loginDone, this.state.artistId, str, this.props.match.params.id)

    // }
    componentWillReceiveProps(nextProps) {

        var str = nextProps.match.params.id;
        if (str != this.props.match.params.id) {
            // on change 
            if (localStorage.hasOwnProperty("userData")) {
                // console.log("changed user id in url with login")
                this.loadArtistData(str);
            }
            return;
        }
        else setTimeout(() => {
            var str = nextProps.match.params.id;
            // debugger;
            // if (this.state.shareUrl || str != this.state.artistId) {

            if (this.state.shareUrl && (!!this.props.authStore.loginDone || this.props.authStore.RegisterSuccess)) {

                this.setState({
                    shareUrl: false,
                    artistId: str
                }, () => {
                    if (localStorage.hasOwnProperty("userData")) {
                        // window.location.reload()
                        this.loadArtistData(str, true);
                        if (this.props.authStore.onboardingThreeIncomplete || this.props.authStore.onboardingTwoIncomplete) {
                            // console.log("hihi tell i am coming here at leats")
                            this.props.navigatorStore.openOB3Modal();

                        }
                        else if (this.props.authStore.RegisterSuccess || localStorage.getItem("just_registered")) {
                            // localStorage.removeItem("just_registered");
                            this.props.navigatorStore.openOB1Modal();

                        }
                    }
                })
            }
        }, 1000)
    }
    handleSeeMore() {
        this.setState({
            seeMore: !this.state.seeMore
        })
    }

    getImageNameReadInstructions = () => this.state.readInstructions ? 'checked' : 'unchecked'
    render() {
        // console.log("re,dering artist details,", this.state.artistData)
        const imageNameInstructions = this.getImageNameReadInstructions();


        if (this.state.wantsToContinue && this.state.readInstructions) {
            return (
                <Redirect push to="/uploadimage2"></Redirect>
            )
        }
        else if (this.state.wantsToContinue && !this.state.readInstructions) {
            this.props.navigatorStore.openErrorModal("Please read all the instructions first");
            this.setState({
                wantsToContinue: false
            })
        }

        return (
            <div className="main-container-artist-detail-page">
                {/* <Helmet>
                    <title>{(this.state.artistData) ? this.state.artistData.length ? this.state.artistData[0].user_profile.display_name || this.state.artistData[0].user_profile.old_display_name : this.state.artistData.user_profile.display_name || this.state.artistData.user_profile.old_display_name : ""}</title>

                    <meta name="description" content={`Artist on YourMasterpieces | ${(this.state.artistData) ? (this.state.artistData.length) ? this.state.artistData[0].user_profile.bio : this.state.artistData.user_profile.bio : ""} `} />

                    <meta property="og:image" content={(this.state.artistData) ? (this.state.artistData.length) ? this.state.artistData[0].user_profile.image : this.state.artistData.user_profile.image : ""}></meta>
                </Helmet> */}
                <OB3 />
                <OB2 />
                <OB1 />
                <div className="artist-detail-background">
                    <img style={{ maxHeight: "260px" }} src={require('../../assets/artist_banner.png')} />
                    <div className="title-artist-page">
                    </div>
                    <FollowBtn share_url={(this.state.artistData) ? (this.state.artistData.length) ? this.state.artistData[0].user_profile.share_url : this.state.artistData.user_profile.share_url : ""}
                        myOwnProfile={this.state.myOwnProfile} handelUploadArtBtnClick={this.handelUploadArtBtnClick.bind(this)} followedThisArtist={this.state.followedThisArtist} handelFollowRequest={this.handelFollowRequest.bind(this)} />

                </div>
                <ArtistBasicInfo
                    viewPortWidth={this.state.viewPortWidth}
                    handleSeeMore={this.handleSeeMore.bind(this)}
                    seeMore={this.state.seeMore}
                    // handleLoadMoreBtn={this.handleLoadMoreBtn.bind(this)}
                    share_url={(this.state.artistData) ? (this.state.artistData.length) ? this.state.artistData[0].user_profile.share_url : this.state.artistData.user_profile.share_url : ""}
                    myOwnProfile={this.state.myOwnProfile}
                    handelUploadArtBtnClick={this.handelUploadArtBtnClick.bind(this)}
                    followedThisArtist={this.state.followedThisArtist}
                    handelFollowRequest={this.handelFollowRequest.bind(this)}
                    artistInfo={this.state.artistData}
                    followersCount={this.state.followersCount}
                    followersCount={this.state.followingCount}
                    handelFollowersListClick={this.handelFollowersListClick.bind(this)}
                    handelFollowingListClick={this.handelFollowingListClick.bind(this)}
                    artist_profile_tags={this.state.artist_profile_tags} />
                <TabsForArtistDetails artworkCount={this.state.artworkCount}
                    shareUrl={this.state.shareUrl}
                    artistId={this.state.artistId}
                    artistUN={this.props.match.params.id}
                    ArtworkData={this.state.artistData}
                    collection={this.state.collection}
                    collectionCount={this.state.collectionCount} />
                <Modal show={this.state.viewFollowersList} onClose={this.onCloseFollowers.bind(this)} >
                    <Modal.Content>
                        {/* followers modal content */}
                        <div className="masterpieces-modal-header pt-20 pb-25 ml-25">
                            <p className="masterpieces-modal-heading">{this.state.artistData.followers} Followers
                            <img onClick={this.onCloseFollowers.bind(this)} className="cross-icon-for-masterpieces-modal" src={require('../../assets/cross_icon_for_close.png')}></img></p>
                        </div>
                        {/* {this.state.uniqueContainerIdFollowers} */}
                        <div className="followers-list-modal-content pt5" id={this.state.uniqueContainerIdFollowers}>
                            <FollowersList
                                loading={this.state.loadingFollowList}
                                close={this.onCloseFollowers.bind(this)} artistFollowersList={this.state.followersList} id={this.state.artistId} />

                        </div>
                    </Modal.Content>
                </Modal>
                <Modal show={this.state.viewFollowingList} onClose={this.onCloseFollowing.bind(this)} id={this.state.uniqueContainerIdFollowing}>
                    <Modal.Content>
                        {/* following modal content */}
                        <div className="masterpieces-modal-header pt-20 pb-25 ml-25">
                            <p className="masterpieces-modal-heading">{this.state.artistData.following} Following
                            <img onClick={this.onCloseFollowing.bind(this)} className="cross-icon-for-masterpieces-modal" src={require('../../assets/cross_icon_for_close.png')}></img></p>
                        </div>
                        {/* {this.state.uniqueContainerIdFollowing} */}
                        <div className="followers-list-modal-content pt5" id={this.state.uniqueContainerIdFollowing} >
                            <FollowersList
                                loading={this.state.loadingFollowList}
                                close={this.onCloseFollowing.bind(this)} artistFollowersList={this.state.followingList} id={this.state.artistId} following={true} />
                        </div>
                    </Modal.Content>
                </Modal>


            </div>
        )
    }
}

const FollowBtn = (props) => {
    return (
        (window.localStorage.hasOwnProperty("userData")) ?
            <div style={{ position: "relative" }}>
                {/* <img style={{ display: (props.myOwnProfile) ? "" : "none" }} alt="" className="upload-art-icon" onClick={() => props.handelUploadArtBtnClick} src={uploadArtIcon} /> */}
                {/* <p className="follow-text-artist-page" style={{ display: (props.myOwnProfile) ? "none" : "", opacity: "1" }}>{(props.followedThisArtist) ? "UNFOLLOW" : "FOLLOW"}</p>
                <Button style={{ display: (props.myOwnProfile) ? "none" : "", border: (props.followedThisArtist) ? "1px solid #BEA57C" : "" }} className="follow-btn-artist-page" onClick={props.handelFollowRequest}>
                </Button>
                <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle nav caret>
                        <Button className="masterpieces-secondary-buttons share-button"
                        // onClick={() => this.handleShareButton(this.state.artworkData.share_url)}
                        >SHARE</Button>
                    </DropdownToggle>
                    <DropdownMenu>
                        <DropdownItem>
                            <FacebookShareButton url={props.share_url}>
                                <FacebookIcon size={32} round={true} />
                            </FacebookShareButton>

                        </DropdownItem>
                        <DropdownItem>
                            <TwitterShareButton url={props.share_url} >
                                <TwitterIcon size={32} round={true} />
                            </TwitterShareButton>
                        </DropdownItem>
                        <DropdownItem>
                            <WhatsappShareButton url={props.share_url} >
                                <WhatsappIcon size={32} round={true} />
                            </WhatsappShareButton>
                        </DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown> */}
            </div>
            : <div></div>
    )

}

const ArtistIdFromUrl = (string) => {
    return (
        string.split("-").pop()
    )
}

const ArtistBasicInfo = (props) => {
    let { artistInfo } = props;
    // console.log("lool look look", artistInfo);
    return (
        (artistInfo && ((artistInfo.length) ? artistInfo[0].user_profile : artistInfo.user_profile)) ?
            //    artistInfo.map((el, elIndex) =>


            <div className="artist-details-slider">
                <div className="container">
                    <div className="col-md-12">
                        <div className="row">

                            <div className="col-12 col-sm-12 col-md-12 col-lg-3 text-center">
                                <div className="border-bg-white-4 mb-25">
                                    <img alt=""
                                        src={((artistInfo.length) ? artistInfo[0].user_profile.image :
                                            artistInfo.user_profile.image) ||
                                            require('../../assets/default_square_picture.png')}
                                        className="artistProfileImg" />
                                </div>
                            </div>

                            <div className="col-12 col-sm-12 col-md-12 col-lg-9">

                                <div className="row pt-15 mb-15">
                                    <div
                                        className="col-12 col-md-12 col-lg-8 d-flex justify-content-center justify-content-lg-start">
                                        <div className="artis-name-block">
                                            <h1 className="artist-name-heading">

                                                {
                                                    (artistInfo.length) ?
                                                        artistInfo[0].user_profile.full_name : artistInfo.user_profile.full_name

                                                }


                                            </h1>
                                        </div>
                                    </div>

                                    <div className="col-12 col-sm-12 col-md-12 col-lg-4 d-flex justify-content-center justify-content-lg-end button-artist-details">
                                        <div className="d-flex justify-content-center justify-content-md-center justify-content-lg-end">
                                            <button onClick={props.handelFollowRequest}
                                                style={{
                                                    cursor: "pointer",
                                                    display: (props.myOwnProfile || !localStorage.hasOwnProperty("userData")) ? "none" : "",
                                                    backgroundColor: (!props.followedThisArtist) ? "#BEA57C" : "#333333"
                                                }} type="button"
                                                className="btn follow-btn-new mr-15 height-36">
                                                {(props.followedThisArtist) ? "UNFOLLOW" : "FOLLOW"}
                                            </button>

                                            <UncontrolledDropdown nav inNavbar>
                                                <DropdownToggle nav caret style={{ padding: "none" }}>

                                                    <button type="button" style={{ color: "black", background: "white" }}
                                                        className="btn share-btn-new share-profile artist-share mr-15 height-36 bg-grey-button">SHARE
                                                    </button>
                                                </DropdownToggle>
                                                <ShareMenu share_url={props.share_url} />
                                            </UncontrolledDropdown>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">

                                    <div className="col-md-12 d-flex justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-start">
                                        <h5 className="attheratetext">
                                            @{
                                                (artistInfo.length)
                                                    ? (artistInfo[0].user_profile.display_name) ? artistInfo[0].user_profile.display_name : artistInfo[0].user_profile.old_display_name :
                                                    (artistInfo.user_profile.display_name) ? artistInfo.user_profile.display_name : artistInfo.user_profile.old_display_name

                                            }
                                        </h5>
                                    </div>

                                    <div className="col-md-12 d-flex justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-start">
                                        {
                                            props.artist_profile_tags.map((el) =>
                                                <span className="explorer-design mr-2">
                                                    {el}
                                                </span>
                                            )
                                        }

                                    </div>

                                    <div className="col-md-12">

                                        <div className="row">
                                            <div className="col-md-12 col-lg-5 d-flex justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-start">
                                                <div className="location">
                                                    <img src={require('../../assets/location.png')} alt="location"
                                                        className="location-img" />
                                                    {(artistInfo.length) ? (artistInfo[0].user_profile && !!artistInfo[0].user_profile.city) ? `${artistInfo[0].user_profile.city}, ` : (artistInfo.user_profile && !!artistInfo.user_profile.city) ? `${artistInfo.user_profile.city}, ` : "" : ""}
                                                    {(artistInfo.length) ? artistInfo[0].user_profile.country || "Unavailable" : artistInfo.user_profile.country || "Unavailable"}
                                                </div>
                                            </div>

                                            <div className="col-md-12 col-lg-7 d-flex justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-end">
                                                <div className="d-flex justify-content-end">
                                                    <Button className="artist-like pull-right"><b
                                                        className="pr-8">{(artistInfo.length) ? artistInfo[0].user_profile.total_likes_received || 0 : artistInfo.user_profile.total_likes_received || 0}</b>
                                                        Likes </Button>
                                                    <Button className="artist-like pull-right"
                                                        onClick={props.handelFollowersListClick}><b
                                                            className="pr-8">{(artistInfo.length) ? artistInfo[0].user_profile.followers || 0 : artistInfo.user_profile.followers || 0}</b>Followers
                                                    </Button>
                                                    <Button className="artist-like pull-right"
                                                        onClick={props.handelFollowingListClick}><b
                                                            className="pr-8">{(artistInfo.length) ? artistInfo[0].user_profile.following || 0 : artistInfo.user_profile.following || 0}</b>
                                                        Following </Button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="bio-section d-flex justify-content-center justify-content-lg-left">
                                                    <h5 className={(props.seeMore) ? "bio-artist-full" : "bio-artist"}
                                                        style={{ '-webkit-box-orient': 'vertical' }}>
                                                        {(artistInfo.length) ? artistInfo[0].user_profile.bio : artistInfo.user_profile.bio}
                                                    </h5>
                                                </div>
                                                <p onClick={props.handleSeeMore}
                                                    style={{
                                                        display: (artistInfo.length) ? artistInfo[0].user_profile.bio.length > props.viewPortWidth ?
                                                            "" : "none" :
                                                            artistInfo.user_profile.bio.length > props.viewPortWidth

                                                                ? "" : "none"
                                                    }}
                                                    className="agree-link bio-see-more-btn">Read {(props.seeMore) ? ` less` : ` more`} </p>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            : <div></div>
    )

}

@inject('userStore', 'navigatorStore', 'authStore', 'commonStore', 'landingPageArtworksStore', 'artworksStore', 'artistDetails', 'followAndLikeStore')
@observer
class TabsForArtistDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            uniqueContainerId: "container_" + new Date().getTime() + Math.random(),
            uniqueContainerId1: "container1_" + new Date().getTime() + Math.random(),
            reachedPageEnd: false,
            activeTab: 1
        }
    }


    componentDidMount() {
        document.addEventListener('scroll', this.trackScrolling);
        // document.addEventListener('scroll', this.trackScrolling);
        this.loadUserArtworks();


        // document.addEventListener('scroll', this.trackScrollingArtworks);
    }
    componentWillUnmount() {
        this.props.artworksStore.resetCollection()
        this.props.artistDetails.reset()

    }
    componentWillReceiveProps() {
        if (this.props.shareUrl) {
            this.loadUserArtworks();
        }
    }
    isBottom(el) {
        return el.getBoundingClientRect().bottom <= window.innerHeight;
    }
    loadFunc() {
        this.props.artworksStore.loadmoreCollection();

        this.loadCollection()
    }

    trackScrolling = () => {
        var wrappedElement;
        if (this.state.activeTab == 2) {
            wrappedElement = document.getElementById(this.state.uniqueContainerId);

        } else {
            wrappedElement = document.getElementById(this.state.uniqueContainerId1)
        }
        if (!wrappedElement) return
        let reachedPageEndNow = this.isBottom(wrappedElement);
        // console.log('[trackScroll] ', { reachedPageEndNow, reachedPageEnd: this.state.reachedPageEnd });
        if (this.isBottom(wrappedElement)) {
            // console.log('[trackScroll] FAKE ');
        };
        if ((reachedPageEndNow && !this.state.reachedPageEnd) || (!reachedPageEndNow && this.state.reachedPageEnd)) {
            this.setState({ reachedPageEnd: reachedPageEndNow })
            // reachedPageEndNow && console.log('[trackScroll] REAL ');
            if (reachedPageEndNow) {
                if (this.state.activeTab == 2) {
                    this.loadFunc()
                } else {
                    this.loadMoreUserArtworks();
                }
            }
        }

    };

    loadMoreUserArtworks() {
        if (localStorage.hasOwnProperty("userData")) {
            this.props.artistDetails.loadMore("private")
        } else {
            this.props.artistDetails.loadMore("public")

        }
        this.loadUserArtworks()
    }
    loadUserArtworks() {
        // console.log("I am comming here tool with", this.props.artistUN);
        // if (!localStorage.hasOwnProperty("userData")) {
        this.props.artistDetails[localStorage.hasOwnProperty("userData") ? "getArtistDetailsPrivate" : "getArtistDetailsPublic"](this.props.artistUN, true)

            .then((resp) => {
                // console.log("this is artist data", resp);
                var joined = (
                    this.state.artworkData && this.props.artworkCount > 0 &&
                    this.props.artistDetails[
                    localStorage.hasOwnProperty("userData") ? "privateApiOffset" : "publicApiOffset"
                    ]) ? this.state.artworkData.concat(resp.data.data) : resp.data.data
                // artistId: resp.data.data[0].id;
                this.setState({
                    artworkCount: resp.data.count,
                    artworkData: joined,

                }, function () {
                    // console.log("this is artist data tool", this.state.artistData)
                    // var tags = [];
                    /* user tags logic */

                    // this.loadOtherData(this.state.artistId, hide)
                }
                )
            })
    }

    loadCollection() {

        // console.log("comming here to load collection ")
        this.props.artistId && this.props.artworksStore.getArtworkCollection(this.props.artistId, true)
            .then((resp) => {
                // console.log("this is collection data", resp);
                var joined = (this.state.collection && this.props.collectionCount > 0) ? this.state.collection.concat(resp.data.data) : resp.data.data
                this.setState({
                    // collectionCount: resp.data.count,
                    collection: joined
                    ,
                    collectionCount: resp.data.count
                    // followedThisArtist: (resp.data.data.length) ? resp.data.data[0].user_profile.isfollowing : resp.data.data.user_profile.isfollowing,
                    // artistId: str.replace(/\D/g, "")
                }, function () {
                    // console.log(resp)
                })
            });
    }

    toggleTabs(tabId) {
        if (!this.state.collectionRendered && tabId == 2) {
            if (localStorage.hasOwnProperty("userData")) {
                this.loadCollection()
            } else {
                this.props.navigatorStore.openSignInModal()
                return;
            }
        }
        // console.log("toggeling", tabId)
        this.setState({
            activeTab: tabId,
            collectionRendered: true,
        }, () => {
            // console.log("something", this.props.artistId)

        })

    }
    handleLoadMoreBtn() {
        this.props.navigatorStore.openSignInModal()
    }
    render() {


        let props = this.props
        // return <Tabs onSelect={(index, label) => console.log(`Selected Index: ${index}, Label: ${label}`)} selected="tab 2">
        //     <Tab label="tab 1">This is Tab 1</Tab>
        //     <Tab label="tab 2">This is Tab 2</Tab>
        //     <Tab label="Disabled" disabled></Tab>
        // </Tabs>
        return (
            <div className="tabs artist-tabs" style={{ marginLeft: "30%", margin: "0px auto", minWidth: "100%", justifyContent: "center", flex: 1 }}>
                {/* 25 Artworks */}

                <div className="tab-button-buying"   >
                    <div className="tab-button-buying" id="profile-details-tab"  >
                        <div className={(this.state.activeTab == 1) ? "profile-details-tab-display-active" : "profile-details-tab-display-inactive"} style={{ flex: 1 }} onClick={() => this.toggleTabs(1)}>{`ARTWORKS ${(props.ArtworkData) ? props.artworkCount || 0 : 0}`}</div>
                        <div className={(this.state.activeTab == 2) ? "profile-details-tab-display-active" : "profile-details-tab-display-inactive"}
                            // disabled = {(!localStorage.hasOwnProperty("userData"))}
                            style={{ flex: 1 }} onClick={() => this.toggleTabs(2)}>{`COLLECTION ${props.collectionCount || 0} `}</div>
                    </div>
                    {
                        <div id={this.state.uniqueContainerId1} style={{ display: (this.state.activeTab == 1) ? "" : "none" }}>

                            {(!props.artworkCount) ?

                                <div className="bg-grey-empty">
                                    <div className="d-flex justify-content-center">
                                        <div className="rectangle-block">
                                            <div className="rectangle-out">
                                                <div className="rectangle-in">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-center">
                                        <div className="container">
                                            <p className="empty-canvas-text">
                                                This user’s canvas is currently blank, please check again later.
                                            You could follow him to nudge him to publish artworks or to see their collection.
                                        </p>
                                        </div>
                                    </div>
                                </div>
                                :
                                <Artworks ArtworkData={(localStorage.hasOwnProperty("userData")) ? this.state.artworkData : this.state.artworkData && this.state.artworkData.slice(0, 4)} />
                            }
                            <div style={{ display: (!localStorage.hasOwnProperty("userData")) ? "" : "none", backgroundColor: "#f6f6f6" }} className="col-md-12 text-center">
                                <Button id="load-more-artworks-btn" onClick={this.handleLoadMoreBtn.bind(this)}
                                    className="masterpieces-tertiary-black-button btn-black btn-p10 mb-45">LOG IN TO SEE MORE</Button>
                            </div>
                        </div>
                    }

                    {/* {props.letsSee} */}
                    <div style={{ display: (this.state.activeTab == 2) ? "" : "none" }}

                        id={this.state.uniqueContainerId} >
                        {/* Rendered here {this.state.uniqueContainerId} */}
                        <div style={{ height: "360px", display: (!props.collectionCount) ? "" : "none", backgroundColor: "#F6F6F6" }}>
                            <p className="empty-canvas-text"> This user has not added any artwork to their collection yet.<br />

                            </p>

                        </div>
                        <ArtworksCollectionCard artworkData={this.state.collection} />
                    </div>

                </div>
            </div>
        )
    }

}

const Artworks = (props) => {
    // console.log("look at props", props.ArtworkData)
    return (
        <div className="artist-artwork-block artwork-detail-block height-initial" style={{ minHeight: localStorage.hasOwnProperty("userdata") ? "-webkit-fill-available" : "auto" }}>
            <section className="artworks-detail-section x-close pb-25" ref={this.myref}>
                <div className="col-md-12">
                    <div className="row">
                        <div className="tabs-container" style={{ marginTop: "25px" }}>
                            <div className="col-md-12">
                                <div className="">
                                    <ArtworkCard artworkData={props.ArtworkData} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

const ArtworksCollectionCard = (props) => {
    return (
        <div className="artist-artwork-block artwork-detail-block height-initial"
            style={{ minHeight: localStorage.hasOwnProperty("userdata") ? "-webkit-fill-available" : "auto" }}>
            <section className="artworks-detail-section x-close pb-25" ref={this.myref}>
                <div className="col-md-12">
                    <div className="row">
                        <div className="tabs-container" style={{ marginTop: "25px" }}>
                            <div className="col-md-12">
                                <div className="" >
                                    <ArtworkCard_ artworkData={props.artworkData} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}







// WEBPACK FOOTER //
// ./src/components/artist/artist_details.js